var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHand = function SvgIconHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.875.5a2.88 2.88 0 0 0-2.635 1.725 2.875 2.875 0 0 0-3.99 2.65v6.134l-.186-.324a2.878 2.878 0 0 0-5.008 2.835c1.518 3.197 2.805 5.507 4.3 7.006C7.932 22.106 9.698 22.75 12 22.75a8.5 8.5 0 0 0 8.5-8.5V6.375a2.875 2.875 0 0 0-3.75-2.738v-.262A2.875 2.875 0 0 0 13.875.5m.875 5.905v-3.03a.875.875 0 0 0-1.75 0v7.875a1 1 0 1 1-2 0V4.847a.875.875 0 0 0-1.75.028v9.872a1 1 0 0 1-1.866.5l-2.053-3.563a.877.877 0 0 0-1.52.876l.037.07c1.531 3.228 2.696 5.252 3.925 6.484C8.925 20.27 10.159 20.75 12 20.75a6.5 6.5 0 0 0 6.5-6.5V6.375a.875.875 0 1 0-1.75 0v4.875a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHand;